'use strict';

/* globals window, $ */

var React = require('react');

var Rhythmist = require('./feed/rhythmist');
var Pagination = require('./feed/pagination.jsx');
var LoadMore = require('./feed/load-more.jsx');
var at = require('./utils/environment');

// Esse import é necessário pro esquema de cards funcionar
require('./authoring/card');

var Feed = React.createClass({
    mixins: [
        Rhythmist,
        Pagination,
        ((at.client && window.$)? LoadMore : {})
    ],

    statics: {
        getAssets: function() { return {
            css: [ 'build/css/bastian.css' ],
            js:  [ 'build/js/bastian-20160223.js' ]
        };}
    },

    dom: {
        $window: ((at.client && window.$)? $(window) : null)
    },

    getFeedId: function() {
        var id;
        try {
            id = this.props.items[0].feedId;
        } catch(e) {
            id = null;
        }
        // method overwritting
        this.getFeedId = function() { return id; };
        return id;
    },

    getReferer: function() {
        var referer = (this.props.referer || null);
        // method overwritting
        if (at.client) this.getReferer = function() { return referer; };
        return referer;
    },

    render: function() {
        var feedId = this.getFeedId();
        var referer = this.getReferer();
        var feedType;
        // var page = this.props.pageIndex;

        if (at.client) {
            feedType = window.SETTINGS.BASTIAN.FEED_TYPE;
        }

        return (
            <div className="bastian"
                 ref="feed"
                 data-feed-id={feedId}
                 data-feed-type={feedType}>
                {this.renderPages()}
                {(at.client && window.$)? this.renderLoadMore(referer) : null}
            </div>
        );
    }
});

module.exports = Feed;
